<template>
  <div class="header_container">
    <div
      class="header_back_button_container"
      @click="onClickBack"
      :style="{ visibility: backVisibility }"
    >
      <img
        class="header_back_button"
        referrerpolicy="no-referrer"
        src="../assets/public/back.png"
      />
    </div>
    <img
      class="header_logo"
      referrerpolicy="no-referrer"
      :src="
        domainName == '灵智鸟'
          ? require('@/assets/public/logo48.png')
          : require('@/assets/public/logo48-2.png')
      "
    />
    <span class="header_logo_text">{{ domainName }}</span>
    <div class="header_title_container">
      <img
        class="header_title_icon"
        referrerpolicy="no-referrer"
        src="../assets/public/lesson-title.png"
        v-if="title !== ''"
      />
      <span class="header_title_text">{{ title }}</span>
    </div>
    <div
      class="header_user_avatar_container"
      @click="onClickUser"
    >
      <img
        class="header_user_avatar"
        referrerpolicy="no-referrer"
        src="../assets/public/user48.png"
      />
    </div>
  </div>
  <div
    class="user_container"
    v-show="showUser"
  >
    <div
      class="user_info_left"
      @click="showUser = false"
    ></div>
    <div class="user_info_container">
      <img
        class="user_avatar"
        referrerpolicy="no-referrer"
        src="../assets/student/user/FigmaDDSSlicePNG9b34a05026f2ec932dadf95d02cfad49.png"
      />
      <div class="user_info flex-col justify-between">
        <span class="user_name">{{ userName }}</span>
        <span class="user_class">{{ userClass }}</span>
        <span
          class="user_id"
          v-if="false"
          >{{ userId }}</span
        >
        <div class="user_folder_container flex-row justify-between">
          <img
            class="user_folder_icon"
            referrerpolicy="no-referrer"
            src="../assets/student/user/FigmaDDSSlicePNGfcaa9f553be0e829de64f24a41f68019.png"
          />
          <span class="folder_text">我的文件夹</span>
        </div>
      </div>
      <div
        class="user_logout_container"
        @click="handleLogout"
      >
        <span class="user_logout_text">登出</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useRouter, useRoute } from "vue-router"

import alovaInstance from "@/utils/alova"
import { formatGradeAndClass } from "@/utils/format"
import { getDomainName } from "@/utils/domainConfig"

// 根据域名获取配置
const domainName = computed(() => getDomainName())

const props = defineProps({
  title: {
    type: String,
    default: "课程",
  },
  backVisibility: {
    type: String,
    default: "visible",
  },
})
const router = useRouter()
const route = useRoute()
const showUser = ref(false)
const userName = ref("")
const userClass = ref("")
const userId = ref("学号")
const isBacking = ref(false)

const onClickBack = () => {
  if (isBacking.value) return
  isBacking.value = true

  const currentFullPath = route.fullPath
  router.back()

  // In iframe pages, the first back may only consume iframe history.
  window.setTimeout(() => {
    if (route.fullPath === currentFullPath) {
      router.back()
    }
    isBacking.value = false
  }, 120)
}

const onClickUser = () => {
  fetchUserInfo()
  showUser.value = true
}

const handleLogout = () => {
  // localStorage.removeItem('jwt_token');
  router.push("/student/login")
}

const fetchUserInfo = async () => {
  try {
    const response = await alovaInstance.Post("/Student/StudentInfo")
    if (response.code === 1000) {
      // console.log(response.data)
      const className = response.data.class_name ?? response.data.class_id ?? ""
      userName.value = response.data.name
      userClass.value = formatGradeAndClass(
        response.data.grade,
        className
      )
    } else {
      alert("获取用户信息失败：" + response.message)
    }
  } catch (error) {
    console.error("获取用户数据失败:", error)
    alert("获取用户数据失败，请稍后重试")
  }
}
</script>

<style scoped>
.header_container {
  background-color: rgba(34, 76, 123, 1);
  width: 100%;
  height: 2.87vw;
  display: flex;
  align-items: center;
}

.header_back_button_container {
  padding: 0.45vw;
  height: 2.87vw;
  margin: 0 0 0 0.46vw;
  cursor: pointer;
}

.header_back_button {
  width: 2.09vw;
  height: 2.09vw;
}

.header_logo {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.05vw 0 0 0.35vw;
}

.header_logo_text {
  color: rgba(255, 255, 255, 1);
  font-size: 1.4vw;
  line-height: 2.87vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  white-space: nowrap;
  margin: 0 0 0 1vw;
}

.header_title_container {
  position: absolute;
  left: 3vw;
  top: 0;
  width: calc(100% - 6vw);
  display: flex;
  justify-content: center;
  align-items: center;
}

.header_title_icon {
  width: 2.09vw;
  height: 2.09vw;
  max-width: 30px;
  max-height: 30px;
  margin: 0.48vw 0 0 0;
}

.header_title_text {
  color: rgba(255, 255, 255, 1);
  font-size: 1.5vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  white-space: nowrap;
  margin: 0.3vw 0 0 1vw;
}

.header_user_avatar_container {
  position: absolute;
  top: 0;
  right: 1.5vw;
  width: 2vw;
  height: 2.87vw;
  cursor: pointer;
}

.header_user_avatar {
  width: 2vw;
  height: 2vw;
  max-width: 40px;
  max-height: 40px;
  margin-top: 0.45vw;
}

.user_container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.user_info_left {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 20vw);
  height: 100%;
  background-color: rgba(33, 57, 82, 0.8);
}

.user_info_container {
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(247, 251, 255, 1);
  width: 20vw;
  height: 56.25vw;
  margin-left: 80vw;
}

.user_avatar {
  width: 7.19vw;
  height: 7.19vw;
  margin: 5.78vw 0 0 6.87vw;
}

.user_class,
.user_name {
  width: 18vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(44, 48, 52, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.78vw 0 0 1.4vw;
}

.user_folder_container {
  width: 9.33vw;
  height: 1.67vw;
  margin: 1.71vw 0 0 5.78vw;
  cursor: pointer;
}

.user_folder_icon {
  width: 1.67vw;
  height: 1.67vw;
}

.folder_text {
  width: 6.25vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.5vw;
}

.user_logout_container {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 17.2vw;
  margin: 20.83vw 0 2.55vw 1.4vw;
  cursor: pointer;
}

.user_logout_text {
  width: 2vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 2.71vw;
  margin: 0.78vw 0 0 7.55vw;
}

@media (max-width: 768px) {
  .header_container {
    height: 7vh;
    min-height: 60px;
  }

  .header_logo_text {
    font-size: 1rem;
    margin: 0 0 0 1vw;
  }

  .header_title_text {
    font-size: 1.1rem;
  }

  .header_title_icon {
    margin: 0 0 0 5vw;
  }
}

@media (max-width: 480px) {
  .header_logo_text {
    display: none;
  }

  .header_title_icon {
    margin: 0 0 0 3vw;
  }
}
</style>
